var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAmountUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5405 11.0624C25.5405 10.0959 26.324 9.31242 27.2905 9.31242H50.6239C51.5904 9.31242 52.3739 10.0959 52.3739 11.0624C52.3739 12.0289 51.5904 12.8124 50.6239 12.8124H27.2905C26.324 12.8124 25.5405 12.0289 25.5405 11.0624Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8613 8.65832C17.5447 9.34173 17.5447 10.4498 16.8613 11.1332L7.52796 20.4665C6.84455 21.1499 5.73651 21.1499 5.05309 20.4665C4.36967 19.7831 4.36967 18.6751 5.05309 17.9916L14.3864 8.65832C15.0698 7.9749 16.1779 7.9749 16.8613 8.65832Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6239 8.14575C16.5904 8.14575 17.3739 8.92925 17.3739 9.89575V49.5624C17.3739 50.5289 16.5904 51.3124 15.6239 51.3124C14.6574 51.3124 13.8739 50.5289 13.8739 49.5624V9.89575C13.8739 8.92925 14.6574 8.14575 15.6239 8.14575Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5405 22.7291C25.5405 21.7626 26.324 20.9791 27.2905 20.9791H45.9572C46.9237 20.9791 47.7072 21.7626 47.7072 22.7291C47.7072 23.6956 46.9237 24.4791 45.9572 24.4791H27.2905C26.324 24.4791 25.5405 23.6956 25.5405 22.7291Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5405 34.3958C25.5405 33.4293 26.324 32.6458 27.2905 32.6458H41.2905C42.257 32.6458 43.0405 33.4293 43.0405 34.3958C43.0405 35.3623 42.257 36.1458 41.2905 36.1458H27.2905C26.324 36.1458 25.5405 35.3623 25.5405 34.3958Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5405 46.0624C25.5405 45.0959 26.324 44.3124 27.2905 44.3124H36.6239C37.5904 44.3124 38.3739 45.0959 38.3739 46.0624C38.3739 47.0289 37.5904 47.8124 36.6239 47.8124H27.2905C26.324 47.8124 25.5405 47.0289 25.5405 46.0624Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAmountUp);
export default __webpack_public_path__ + "static/media/sort-amount-up.0e11d9f5.svg";
export { ForwardRef as ReactComponent };